import { Observable, of } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';
import { ComponentDataSourceService } from '../../component-data-source/component-data-source.service';
import { environment } from '../../../environment/environment';
import { DataSharingService } from '../../data-sharing/data-sharing.service';

export interface UpdateSubtypeRequest {
  subtype_id: number;
  name?: string;
  visibility?: string;
}

export interface UpdateSubtypeResponse {
  success: boolean;
  message: string;
  subtype_id?: number;
  error?: string;
}

export function updateSubtype(componentDataSourceService: ComponentDataSourceService) {
  const dataSharingService = componentDataSourceService.injector.get(DataSharingService);

  return {
    name: 'UpdateSubtype',
    description: 'Updates an existing subtype name and/or visibility',
    execute: (data: UpdateSubtypeRequest): Observable<UpdateSubtypeResponse> => {
      if (!data.subtype_id) {
        return of({
          success: false,
          message: 'No subtype_id provided',
          error: 'Missing required subtype_id'
        });
      }

      const updatePayload: { name?: string; visibility?: string } = {};
      if (data.name !== undefined) updatePayload.name = data.name;
      if (data.visibility !== undefined) updatePayload.visibility = data.visibility;

      return componentDataSourceService.http.patch<UpdateSubtypeResponse>(
        `${environment.apiUrl}/events/subtypes/${data.subtype_id}`,
        updatePayload,
        { headers: { 'Content-Type': 'application/json' } }
      ).pipe(
        tap(response => {
          if (response?.success) {
            dataSharingService.setData('subtypes_updated', {
              timestamp: Date.now(),
              subtype_id: data.subtype_id
            });
          }
        }),
        catchError(error => {
          console.error('[UpdateSubtype] HTTP error:', error);
          throw error;
        })
      );
    }
  };
}
